import { PRODUCT_IDS } from '@adsk/alloy-provider';

export const USER_ACCESSES = {
  MEMBER: 'Project Member',
  ADMIN: 'Project Admin',
};

export const basicProductsList = [
  {
    included: false,
    type: PRODUCT_IDS.DOCS,
    name: 'Docs',
    userAssignable: true,
  },
  {
    included: false,
    type: PRODUCT_IDS.DESIGN_COLLABORATION,
    name: 'Design Collaboration',
    userAssignable: true,
  },
  {
    included: false,
    type: PRODUCT_IDS.MODEL_COORDINATION,
    name: 'Model Coordination',
    userAssignable: true,
  },
  {
    included: false,
    type: PRODUCT_IDS.TAKEOFF,
    name: 'Takeoff',
    userAssignable: true,
  },
  {
    included: false,
    type: PRODUCT_IDS.BUILD,
    name: 'Build',
    userAssignable: true,
  },
  {
    included: false,
    type: PRODUCT_IDS.COST,
    name: 'Cost',
    userAssignable: true,
  },
  {
    included: false,
    type: PRODUCT_IDS.INSIGHT,
    name: 'Insight',
    userAssignable: false,
  },
];

export const productsList = [
  ...basicProductsList,
  {
    included: false,
    type: PRODUCT_IDS.AUTOSPECS,
    name: 'AutoSpecs',
    userAssignable: true,
  },
];
